<template>
  <div class="single-list-create">
    <div class="linear-background"></div>
  </div>
</template>

<script>
export default {
  name: 'Create-List-Floating-Label'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .single-list-create {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    div {
      width: 160px;
      border-radius: 35px;
      height: 24px;
    }
  }
</style>
